export enum DimensionName {
  LENGTH = "length",
  WIDTH = "width",
  HEIGHT = "height",
  GIRTH = "girth",
  TOTAL = "longest side plus girth",
}

export enum BoxSide {
  A = "A",
  B = "B",
  C = "C",
  G = "G",
  T = "T",
}

export type BoxDimension = {
  name: DimensionName;
  fieldName: string;
  value: number;
};

export type BoxGirth = {
  B: BoxDimension;
  C: BoxDimension;
};

export type BoxWeight = {
  name: string;
  fieldName: string;
  value: number;
};
